<template>
    <div>
        <el-dialog title="" :visible.sync="searchFor" width="75%" custom-class="searchLabel" :show-close="false" @close="cancel" @open="searchDialogEvt">
            <div style="width: 90%;height:100%">
                <div class="space" style="float: left; margin-left: 20px">
                    <div class="check">
                        <div v-for="item in labelArr" :key="item.id">
                                <p :style="{color:item.one == true? '#409EFF':'#595959'}">{{ item.title }}</p>
                            <div class="checkbox" v-for="e in item.children" :key="e.id" @click="searchLabEvt(e)">
                                <i></i>
                                <b v-if="e.status == 3"></b>
                                <b v-else-if="e.status == 0" style="background-color: green"></b>
                                <b v-else-if="e.status == 1" style="background-color: #f00"></b>
                                <b v-else-if="e.status == 2" style="background-color: #999"></b>
                                <span >{{ e.title }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="small"  @click="cancel">取 消</el-button>
                <el-button size="small" @click="revise" type="primary">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { getLabelApi,getVdtCodeApi } from "../apis/ces/a";
import {
    PSImgApi,
    getPSLabelApi,
    getPSImgLabelApi,
    
    stickLabelApi,
    rightStickLabelApi
 } from '../apis/ps'
    export default {
        props:["searchFor","process","type","author","time","frontOrder","operateLabelInput",'labelId','checkInput',],
        data() {
            return {
                labelArr:[],
                LabelSelected:[]
            };
        },

        mounted() {
        },

        methods: {
            cancel(e){
                this.$emit('cancel', false);
            },
            searchDialogEvt(){
                getPSLabelApi({
                    type:this.$props.type,process:this.$store.getters.PSprocess,
                }).then(res => this.labelArr = res.data.tag)
            },
            searchLabEvt(e) {
                this.LabelSelected.map((res,index)=>{
                    if(res.id ==e.id){
                        this.LabelSelected.splice( index, 1)
                    }
                })
                if(this.LabelSelected.length == 6){
                    this.$message({
                        message: '最多选中6个哦',
                        type: 'warning'
                    });
                    return 
                }
                this.labelArr = this.labelArr.map((val) => {
                    for (let key in val.children) {
                       if (e.id == val.children[key].id) {

                            if(val.children[key].status==0){
                                val.children[key].status = 1
                            }else{
                                val.children[key].status = 0
                            }
                            this.LabelSelected.push(val.children[key])
                        }
                   
                    }
                    return val;
                });
        },
        revise(){
            let is_tag =this.LabelSelected.filter((res) => res.status == 0)
            let not_tag =  this.LabelSelected.filter((res) => res.status == 1)
            is_tag = is_tag.map(res=>{return res.id})
            not_tag = not_tag.map(res=>{return res.id})
            
            PSImgApi({
                    type:this.$props.type,
                    process:this.$store.getters.PSprocess,
                    author:this.$props.author,
                    time:this.$props.time,
                    source_id:this.$props.frontOrder,
                    is_tag,
                    not_tag
                }).then(res=>{
                    if(res.code ==1000){
                        this.$emit('revise', res.data);
                        this.$emit('cancel', false);
                        this.$emit('reviseText',this.LabelSelected)
                        this.LabelSelected =[]
                    }
                })
        }
        },
     
};
</script>
<style  scoped>

.check {
    display: flex;
}

.check div {
    width: 100px;
}

.check div p {
    margin: 0;
    font-size: 14px;
    margin-bottom: 25px;
    padding-left: 14px;

}

.check div .checkbox {
    width: 100%;
    margin-top: 15px;
    position: relative;
    cursor: pointer;
}

.check div .checkbox i {
    display: block;
    width: 12px;
    height: 12px;
    float: left;
    border-radius: 50%;
    border: 1px solid #999;
    margin-right: 5px;
    margin-top: 2px;
}

.check div .checkbox b {
    display: block;
    width: 8px;
    height: 8px;
    position: absolute;
    top: 4px;
    left: 2px;
    border-radius: 50%;
}
>>>.searchLabel {
    min-width: 1250px;
    min-height: 610px
}


</style>


// WEBPACK FOOTER //
// src/material/material.vue